import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Drawer } from '~/components';
import { useApi, useWorkspace } from '~/contexts';
import { PageLoader } from '~/routes/public/pages';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

const Log = styled.code`
  font-size: 0.875rem;
  white-space: pre-wrap;
`;

export default function SyncLogDrawer({ id, onClose }) {
  const api = useApi();
  const { workspace } = useWorkspace();
  const { xeroConnectionId } = useParams();
  const [isReady, setIsReady] = useState(false);
  const [log, setLog] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.www.workspaces(workspace.id).xero(xeroConnectionId).getSyncLog(id);
        if (!cancelled) setLog(data);
      } finally {
        if (!cancelled) setIsReady(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [api, workspace, id, xeroConnectionId]);

  return (
    <Drawer isOpen title="Sync Log" byline="Xero Integration" onClose={onClose}>
      {() => {
        if (!isReady) {
          return <PageLoader />;
        }
        return <Log>{log}</Log>;
      }}
    </Drawer>
  );
}
